import React, { lazy } from 'react';

// 机器人登录页
const LoginForRobot = lazy(() => import('@/pages/robotV2/Login'));
const RobotHome = lazy(() => import('@/pages/robotV2/Home'));
const PsychologicalAIConsultantWithPrompt = lazy(() => import('@/pages/robotV2/PsychologicalAIConsultation/PsychologicalAIConsultantWithPrompt'));
const PsychologicalAIConsultant = lazy(() => import('@/pages/robotV2/PsychologicalAIConsultation'));
const PsychologicalAIEvaluation = lazy(() => import('@/pages/robotV2/PsychologicalAIConsultation/PsychologicalAIEvaluation'));


const robotRoutes = [
  { path: '/robot-v2/login', component: <LoginForRobot />, needInterceptor: false },
  { path: '/robot-v2/home', component: <RobotHome />, needInterceptor: true },
  { path: '/robot-v2/psychological-ai-consultant-with-prompt', component: <PsychologicalAIConsultantWithPrompt />, needInterceptor: true },
  { path: '/robot-v2/psychological-ai-consultant', component: <PsychologicalAIConsultant />, needInterceptor: true },
  { path: '/robot-v2/psychological-ai-evaluation', component: <PsychologicalAIEvaluation />, needInterceptor: true },
  
];

export default robotRoutes;
